
<template>
  <div id="cropme">
    
      <Menutop></Menutop>
      <!-- .container -> max 1200px Breite -->
      <!-- .container-fluid -> kein max Breite -->
      <div class="row container-fluid">
        <Cropmeleft 
          :aktueller-vorgang="aktuellerVorgang"
          :anzahlOffeneVorgaenge="anzahlOffeneVorgaenge"
          :offeneVorgaenge="offeneVorgaenge"
          :customer="customer"></Cropmeleft>
        <Cropmemain
          v-bind:vorgang_id="aktuellerVorgang"
          v-bind:customer="customer">
          </Cropmemain>
      </div>
      <Footer></Footer>
    
  </div>
</template>

<script>
import Menutop from '../components/Menutop.vue';
import Cropmeleft from '../components/Cropmeleft.vue';
import Cropmemain from '../components/Cropmemain.vue';
import Footer from '../components/Footer.vue';
// kommt von pinegrow/bootstrap4:
import '../components/sticky-footer-navbar.css';
import axios from 'axios';

// Mixin fuer diese Komponente importieren
import loginzustand from './mixins/loginzustand.js';
import commonvars from './mixins/commonvars.js';

export default {
  name: 'Cropme',
  mixins: [
    loginzustand,
    commonvars
  ],
  components: {
    Cropmeleft,
    Cropmemain,
    Menutop,
    Footer
  },
  // props fuer Kinder mit CamelCase
  data() {
    return {
      customer: this.$route.params.customer,
      aktuellerVorgang: this.$route.params.vorgang,
      offeneVorgaenge: [],
      anzahlOffeneVorgaenge: 0
    }
  },
  mounted: function() {
    this.api_loginzustand_feststellen();
    this.get_offene_vorgaenge_ids();
  },
  methods: {
    offene_vorgaenge_fuer_customer_url() {
      return this.server_base_url()
      + "/api/vorgaenge/customer/"
      + this.customer
      + "/offen";
    },
    get_offene_vorgaenge_ids() {
      let url = this.offene_vorgaenge_fuer_customer_url();
      console.log(url);
      
      axios
        .get(url)
        .then(
          response => {
            this.offeneVorgaenge = response.data.offene_vorgaenge;
            this.anzahlOffeneVorgaenge = response.data.anzahl_offene_vorgaenge;
          }
      );
    }
  }
}
</script>

